import { IMPORT_FIELD_DEFS, type ImportType } from '@finvox/shared/import';

const SAMPLE_ROWS: Record<ImportType, string[][]> = {
  coa: [
    ['1000', 'Cash', 'نقدية', 'asset'],
    ['2000', 'Accounts payable', 'دائنون', 'liability'],
    ['4000', 'Revenue', 'إيرادات', 'revenue']
  ],
  opening_balances: [
    ['1000', '5000.00', '0.00', 'ob-1000'],
    ['2000', '0.00', '5000.00', 'ob-2000']
  ],
  customers: [['C001', 'Acme Corp', 'شركة أكمي', 'billing@acme.test', '', 'cust-c001']],
  vendors: [['V001', 'Supply Co', 'شركة التوريد', '', 'vend-v001']],
  tax_definitions: [['VAT 14%', 'ضريبة 14%', '14', '', 'false', 'tax-vat14']]
};

export function downloadImportSample(importType: ImportType): void {
  const fields = IMPORT_FIELD_DEFS[importType];
  const headers = fields.map((f) => f.key);
  const rows = SAMPLE_ROWS[importType];
  const lines = [
    headers.join(','),
    ...rows.map((r) => r.map((c) => (c.includes(',') ? `"${c}"` : c)).join(','))
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `finvox-${importType}-sample.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
